<template>
  <div class="tab__content">
    <a
      download
      href="https://riverrunes.gg/docs/official-position-of-the-competition.pdf"
      >Скачать официальное положение о соревнованиях «Red Bull River Runes»</a
    >

    <div class="rules-frame mt-4">
      <iframe
        src="//docs.google.com/viewer?embedded=true&url=https://riverrunes.gg/docs/official-position-of-the-competition.pdf"
        height="400px"
        width="100%"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import tournamentsService from "@/services/tournaments";

export default {
  data: () => ({
    loading: false
  }),

  computed: {
    ...mapGetters(["routeParams"]),
    ...mapGetters("tournaments", ["tournament"])
  },

  methods: {
    async fetchPageData() {
      if (this.loading) return;
      this.loading = true;
      let data = await tournamentsService.getRules(
        this.routeParams.tournament_id
      );
      this.$store.dispatch("tournaments/updateTournament", data);
      this.loading = false;
    }
  }
};
</script>
